import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PinIcon = function PinIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.507 17",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "0.8")
  }, [h("path", {
    d: "M7.25.55h0a6.69 6.69 0 0 1 4.6 11.549l-4.6 4.351-4.6-4.35A6.69 6.69 0 0 1 7.25.55Z"
  }), h("path", {
    d: "M9.684 6.583a2.43 2.43 0 1 1-2.43-2.43 2.43 2.43 0 0 1 2.43 2.43Z"
  })]));
};